<template>
  <div class='hijackable-asset-issue-body'>
    <div class="description-block">
      <div class="data-title">{{$t('detailed.issue.description.title')}}</div>
      <div class="text-container">
        {{description}}
      </div>
    </div>
    <div class="asset-block">
      <div class="data-title">{{$t('detailed.issue.asset.title')}}</div>
      <div class="text-container">
        {{asset}}
      </div>
    </div>
    <div class="tld-block">
      <div class="data-title">{{$t('detailed.issue.tld.title')}}</div>
      <div class="text-container">
        {{tld}}
      </div>
    </div>
    <div class="hackers-view-block">
      <div class="data-title">{{$t('detailed.issue.hackers.view.title')}}</div>
      <div class="text-container">
        {{hackersView}}
      </div>
    </div>
    <span class="solution-block" v-if='solutions.length'>
      <div class="data-title">{{$t('detailed.issue.mitigation.title')}}</div>
        <div v-for='(solution, index) in solutions' :key='index'>
         <div class='mitigation-option'>
          <div class='data-title option'>
            <span class="material-icons bullet">
              lens_blur
            </span>
          </div>
         <div class='text-container'>{{solution}}</div>
        </div>
      </div>
    </span>
    <div class="technical-block">
      <div class="data-title">{{$t('issueDataPopup.technical.data')}}</div>
      <div class="technical-data">
        <div class='text-container'>
          <div class='details-column technical-data'>
            <div class="data-sub-title">{{$t('issueDataPopup.url')}}</div>
            <div class='text-container cve-url'>
              <a :href='url.link' target="_blank"> {{url.text}} </a>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'HijackableAssetIssueBody',
  props: {
    issue: {
      type: Object,
      required: true,
    },
  },
  computed: {
    tld() {
      return this.issue.tld;
    },
    asset() {
      return this.issue.asset;
    },
    metaData() {
      return this.issue.metaData;
    },
    description() {
      return this.issue.metaData.description;
    },
    hackersView() {
      return this.issue.metaData.hackersView;
    },
    mitigation() {
      return this.issue.metaData.mitigation;
    },
    url() {
      return {link: this.issue.metaData.url, text: this.$t('detailed.issue.hijack.url')};
    },
    solutions() {
      return this.mitigation.split('\n\n');
    },
  },
};
</script>

<style lang='scss' scoped>
@import '~@/assets/styles/design-system';

.hijackable-asset-issue-body {
  .details-column {
    display: inline-block;
    width: fit-content;
    max-width: rem(650);
    margin-right: $space-4;
  }
  .description-block, .hackers-view-block {
    display: block;
    width: rem(650);
    .text-container::first-letter {
      text-transform: capitalize;
    }
    .text-container {
      padding-right: rem(60);
      font-size: $font-size-base;
      letter-spacing: 0;
      line-height: rem(18);
      padding-bottom: $space-5;
      white-space: pre-line;
    }
  }
  .solution-block {
    display: block;
    padding-bottom: $space-5;
    width: rem(650);
    .bullet {
      flex: 1;
    }
    .text-container {
      padding-left: rem(5);
      padding-right: rem(60);
      color: var(--text-primary);
      font-size: $font-size-base;
      letter-spacing: 0;
      line-height: rem(18);
      padding-bottom: $space-4;
    }
    .mitigation-option {
      display: flex;
    }
    .material-icons {
      font-size: rem(15);
      opacity: 0.5;
      margin-top: rem(3);
    }
  }
  .technical-block {
    padding-bottom: $space-5;
    display: block;
    .technical-data {
      padding-top: rem(4);
      .url {
        width: rem(650);
        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;
      }
    }
  }
  .data-sub-title {
    font-size: $font-size-xs;
    color: var(--text-secondary);
    letter-spacing: rem(0.8);
    line-height: $font-size-xs;
    text-transform: uppercase;
    margin-bottom: $space-1;
  }
  .data-title {
    color: var(--text-secondary);
    font-size: $font-size-sm;
    letter-spacing: rem(0.8);
    line-height: $font-size-xs;
    text-transform: uppercase;
    margin-bottom: $space-1;
  }
  .asset-block {
    margin-bottom: $space-5;
  }
  .tld-block {
    margin-bottom: $space-5;
  }
}
</style>
